import { render, staticRenderFns } from "./RecentUpdates.vue?vue&type=template&id=88243c9e&scoped=true"
import script from "./RecentUpdates.vue?vue&type=script&lang=js"
export * from "./RecentUpdates.vue?vue&type=script&lang=js"
import style0 from "./RecentUpdates.vue?vue&type=style&index=0&id=88243c9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88243c9e",
  null
  
)

export default component.exports